/* ============================================================
   entorno-pdp-atc.js
   Intercepta el Add to Cart del PDP para actualizar el contador
   del nav con la misma animación bump que la shop page.

   El tema usa product-form.js que ya maneja el AJAX internamente.
   Después de agregar al carrito publica PUB_SUB_EVENTS.cartUpdate.
   Escuchamos ese evento + el formulario directamente como fallback.
   ============================================================ */

(function () {

  /* ---- Reutiliza bumpCartCount si ya existe (definida en la shop page)
         o define una versión propia para el PDP ---- */
  function bumpCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var el = document.querySelector('.ent-nav__cart');
        if (!el) return;
        el.textContent = 'Carrito (' + c.item_count + ')';
        el.classList.remove('ent-cart-bump');
        void el.offsetWidth; /* reflow para reiniciar animación */
        el.classList.add('ent-cart-bump');
      })
      .catch(function () {});
  }

  /* ---- Método 1: PubSub nativo del tema ----
     product-form.js publica 'cartUpdate' después de cada ATC exitoso.
     subscribe() es una utilidad global definida en theme.js del tema. */
  function tryPubSub() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      /* Solo reaccionar a eventos originados desde el formulario de producto,
         no desde el cart-items (que ya actualiza el footer) */
      if (event && event.source === 'cart-items') return;
      bumpCartCount();
    });
    return true;
  }

  /* ---- Método 2: Interceptar el formulario directamente ----
     Escucha el submit del form con id product-form-* y
     hace el fetch a /cart/add.js replicando la misma lógica. */
  function tryFormIntercept() {
    /* El botón de ATC en el PDP tiene clase product-form__submit
       y pertenece a un <product-form> custom element que ya maneja
       el AJAX. Solo necesitamos saber cuaíndo termina.
       Observamos el atributo 'data-type' del form o el botton loading state. */

    /* Alternativa más robusta: escuchar fetch a /cart/add */
    var _fetch = window.fetch;
    window.fetch = function (url) {
      var args = arguments;
      var p = _fetch.apply(this, args);

      /* Solo interceptar llamadas al endpoint de add */
      var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
      if (urlStr.indexOf('/cart/add') !== -1) {
        p.then(function (response) {
          /* Clonar para no consumir el body original */
          var cloned = response.clone();
          cloned.json().then(function (data) {
            /* Si la respuesta tiene items o id, fue exitosa */
            if (data && (data.id || (data.items && data.items.length))) {
              bumpCartCount();
            }
          }).catch(function () {});
          return response;
        }).catch(function () {});
      }

      return p;
    };
  }

  /* ---- Inicializar cuando el DOM esté listo ---- */
  function init() {
    /* Solo actuar en páginas de producto */
    if (!document.body.classList.contains('lx-template--product')) return;

    /* Intentar PubSub primero (más limpio), fetch-intercept como fallback */
    var pubSubOk = tryPubSub();
    if (!pubSubOk) {
      /* PubSub no disponible todavía, esperar 500ms y reintentar */
      setTimeout(function () {
        if (!tryPubSub()) {
          /* Fallback definitivo: interceptar fetch */
          tryFormIntercept();
        }
      }, 500);
    }

    /* Siempre instalar el intercept de fetch como segunda capa
       por si PubSub no se dispara en todos los casos */
    tryFormIntercept();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
